import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaClipboardList } from 'react-icons/fa';

export default function JupasSurveySuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const anonymous = Boolean(location.state?.anonymous);

  return (
    <div className="jupas-survey-home relative overflow-hidden bg-canvas">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-emerald-100/85 via-emerald-50/35 to-transparent dark:from-emerald-950/45 dark:via-emerald-950/10 dark:to-transparent"
        aria-hidden
      />
      <div
        className="jupas-survey-home-blob-a pointer-events-none absolute -right-20 top-10 h-64 w-64 rounded-full bg-emerald-400/15 blur-3xl dark:bg-emerald-500/20"
        aria-hidden
      />
      <div
        className="jupas-survey-home-blob-b pointer-events-none absolute -left-20 top-28 h-52 w-52 rounded-full bg-primary/10 blur-3xl dark:bg-primary/20"
        aria-hidden
      />

      <div className="relative mx-auto flex w-full max-w-3xl flex-col px-4 pb-10 pt-6 sm:px-6 sm:pb-12 sm:pt-10">
        <div className="mx-auto w-full max-w-xl rounded-2xl border border-edge bg-surface/95 p-6 text-center shadow-sm backdrop-blur-sm sm:p-8">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 dark:bg-emerald-950/60 dark:text-emerald-300">
            <FaCheckCircle className="h-8 w-8" aria-hidden />
          </div>

          <h1 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            {t('jupasListSubmission.success.title')}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-ink-muted sm:text-base">
            {anonymous
              ? t('jupasListSubmission.success.bodyAnonymous')
              : t('jupasListSubmission.success.bodyAccount')}
          </p>

          <div className="mt-6 flex flex-col gap-2.5 sm:flex-row sm:justify-center">
            <Link
              to="/jupas-survey"
              className="inline-flex h-10 items-center justify-center gap-2 rounded-full bg-primary px-5 text-sm font-semibold text-primary-foreground shadow-sm transition hover:bg-primary/90"
            >
              <FaClipboardList className="h-4 w-4 shrink-0" aria-hidden />
              {t('jupasListSubmission.success.backToHome')}
            </Link>
            <Link
              to="/"
              className="inline-flex h-10 items-center justify-center rounded-full border border-edge bg-surface px-5 text-sm font-semibold text-ink-muted transition hover:border-edge-strong hover:bg-surface-muted hover:text-ink"
            >
              {t('jupasListSubmission.success.backToEdvise')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
